import type { GetAnonymousCustomersReportResponse } from '@vy/api-definition';
import { GetAnonymousCustomersReportResponseSchema } from '@vy/api-definition';
import { validateNotNullOrUndefined, withDefault } from '@vy/utils';
import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';

export function useAnonymousCustomersReport(
  reportId?: string,
  options?: UseQueryOptions<GetAnonymousCustomersReportResponse>,
) {
  const getAnonymousCustomersQuery = useQuery({
    queryKey: queryKeys.anonymousCustomersReport(withDefault(reportId, '')),
    queryFn: async () => {
      const privateApi = getPrivateApi();

      const getAnonymousCustomersDataResponse = await privateApi.getAnonymousCustomersReport({ reportId });

      return GetAnonymousCustomersReportResponseSchema.parse(getAnonymousCustomersDataResponse);
    },
    suspense: true,
    ...options,
  });

  validateNotNullOrUndefined(getAnonymousCustomersQuery.data, 'getAnonymousCustomersQuery data');

  return getAnonymousCustomersQuery;
}
